import React from "react";

import { getBenefit, getBenefitItem } from "./config";
import * as S from "./styles";

export default function BenefitsDetails({ benefits }) {
  const benefitsKeys = Object.keys(benefits);

  return (
    <S.Benefits>
      {benefitsKeys?.map((key) => {
        const { title, icon } = getBenefit(key);

        return (
          <S.Benefit key={key}>
            <S.Icon>{icon}</S.Icon>
            <S.Title>{title}</S.Title>

            <S.Scroll>
              {benefits[key]?.map((benefit) => (
                <ul key={benefit?.id}>
                  <li>
                    <strong>{benefit?.concept}</strong>
                  </li>

                  {getBenefitItem({ key, benefit })?.map(
                    ({ label, value = "-" }) => (
                      <li key={label}>
                        {label} <span>{value}</span>
                      </li>
                    )
                  )}
                </ul>
              ))}
            </S.Scroll>
          </S.Benefit>
        );
      })}
    </S.Benefits>
  );
}
